import { FC } from 'react';
import { SvgProps } from './domain';

const Headset: FC<SvgProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1796_466)'>
        <path
          d='M9.13546 24.0001C9.9702 24.0001 10.6469 23.3373 10.6469 22.5196C10.6469 21.7019 9.9702 21.0391 9.13546 21.0391C8.30072 21.0391 7.62402 21.7019 7.62402 22.5196C7.62402 23.3373 8.30072 24.0001 9.13546 24.0001Z'
          fill='#03E4B3'
        />
        <path
          d='M21.8188 7.48052H20.6605C20.1228 3.26338 16.4508 0 11.9992 0C7.54763 0 3.87723 3.26338 3.33948 7.48052H2.18124C0.976864 7.48052 0 8.4374 0 9.61714V13.8919C0 15.0717 0.976864 16.0286 2.18124 16.0286H5.45389V8.54805C5.45389 5.00727 8.38449 2.13662 11.9992 2.13662C15.6139 2.13662 18.5445 5.00727 18.5445 8.54805V14.9595C18.5445 18.3943 15.7873 21.1979 12.3222 21.3631C12.2681 21.3553 12.214 21.3506 12.1583 21.3506C11.5426 21.3506 11.0446 21.8384 11.0446 22.4416C11.0446 23.0447 11.5426 23.5325 12.1583 23.5325C12.2522 23.5325 12.3429 23.52 12.4304 23.4982C16.6847 23.2956 20.1403 20.1086 20.6605 16.0286H21.8188C23.0231 16.0286 24 15.0717 24 13.8919V9.61714C24 8.4374 23.0231 7.48052 21.8188 7.48052ZM3.27265 13.8919H2.18124V9.61714H3.27265V13.8919ZM21.8188 13.8919H20.7273V9.61714H21.8188V13.8919Z'
          fill='url(#paint0_linear_1796_466)'
        />
        <path
          d='M16.6257 15.7995L15.4691 13.9871C14.4636 14.6042 13.2735 14.9611 11.9991 14.9611C10.7248 14.9611 9.53471 14.6042 8.5292 13.9871L7.37256 15.7995C8.71376 16.6224 10.3 17.0977 11.9991 17.0977C13.6983 17.0977 15.2845 16.6224 16.6257 15.7995Z'
          fill='url(#paint1_linear_1796_466)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1796_466'
          x1='11.9992'
          y1='23.5325'
          x2='11.9992'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.2' stopColor='#03E4B3' />
          <stop offset='1' stopColor='#007FF1' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1796_466'
          x1='11.9991'
          y1='17.0977'
          x2='11.9991'
          y2='13.9871'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.2' stopColor='#03E4B3' />
          <stop offset='1' stopColor='#007FF1' />
        </linearGradient>
        <clipPath id='clip0_1796_466'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Headset;
